<template>
    <div>
  
      <h1 class="pb-2">
       <icons :icon="['fas', 'award']" /> 
        <strong>DISCOGRÁFICAS</strong>
       <icons :icon="['fas', 'award']" /> 
       </h1>  
        <p> 
          Como somos tan raritos y nos gusta un solo género musical hemos decidido asociarnos con otras discográficas igual de raritas que nosotros, a ver que os parecen.
        </p>
  
  
          
        <div class="container-md">
            <b-card-group columns>
              <div columns v-for="proyecto in proyectos" :key="proyecto.id">
               <OtrasDiscograficas :autor="proyecto.autor" :srcimg="proyecto.srcimg" :alt="proyecto.alt" :titulo="proyecto.titulo" :texto="proyecto.texto" :url="proyecto.url"></OtrasDiscograficas> 
              </div>
             </b-card-group>
         </div>
  
  
   </div>
  
  </template>
  
  <script>
  import OtrasDiscograficas from '../components/OtrasDiscograficas.vue' 
  //(para utilizar en localhos)
  //const lstProysJson = '/public/../proyectosWD2021.json';
  //para utilizar en produccion
  const lstProysJson = 'https://raw.githubusercontent.com/ccm24/rock_records/main/OtrasDiscograficas.json';
  
  export default {
    props: {  
     name: {
        type: String,
        default: 'DiscograficasRock'
      }
    },
    components: {
          OtrasDiscograficas
        },
    data() {
        return {
          proyectos:[],
          githubPage: 1,
          page: 1,
          loading: false,
          perPage: 5
        }
      },
      mounted() {
        this.fetchData()
      },

      methods: {
          async fetchData() {
            const res = await fetch (lstProysJson);
            const val= await res.json();
            this.proyectos=val;
            console.log(val);
          }
      }
    }
  </script>
  